import {
	HttpParamsBuilder,
	Meta,
	PropertyFilter,
	Response,
	Vehicle,
	VehiclesApiService,
} from '@agilox/common';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

@Injectable()
export class VehiclesSelectService {
	private vehiclesApiService = inject(VehiclesApiService);

	fetchVehicles(
		search: string,
		page: Meta,
		serials?: string[],
		unions?: string[],
		propertyFilters?: PropertyFilter[]
	): Observable<Response<Vehicle>> {
		let params = HttpParamsBuilder.buildParameters(
			page,
			undefined,
			search,
			undefined,
			propertyFilters
		);

		/**
		 * If the search string is empty we use the prioritize parameter
		 */
		if (!search) {
			if (unions?.length) {
				params = params.append('prioritize[unionUuid]', unions.join(','));
			} else if (serials?.length) {
				params = params.append('prioritize[serial]', serials.join(','));
			}
		}

		return this.vehiclesApiService.fetch(params).pipe(
			catchError(() => {
				return of({
					data: [],
					meta: {
						number: 0,
						size: 0,
						total: 0,
					},
					status: true,
				});
			})
		);
	}
}
